var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationIconWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/\uEB8E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Self-check-Cargill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-level-entrance-Copy",
    transform: "translate(-1074.000000, -700.000000)",
    fill: "#EF3C41",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(77.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify",
    transform: "translate(997.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99310345,109.72 L9.99310345,104.92 L8.40689655,104.92 L8.40689655,109.72 L9.99310345,109.72 Z M9.99310345,112.6 L9.99310345,110.84 L8.40689655,110.84 L8.40689655,112.6 L9.99310345,112.6 Z M0,115 L9.2,99 L18.4,115 L0,115 Z",
    id: "\\uEB8E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIconWarning);
export default __webpack_public_path__ + "static/media/verification_icon_warning.14b04dcfb256a651720c88649dd816d3.svg";
export { ForwardRef as ReactComponent };